<template>
  <component
    :is="banner.urlPath ? UiSmartLink : 'div'"
    v-bind="linkAttributes"
    v-element-visibility="onBannerImpression"
    class="product-listing-banner"
    @click="onBannerClicked"
  >
    <UiSmartImage v-bind="banner.img" aspect-ratio="9/16" />
  </component>
</template>

<script lang="ts" setup>
import UiSmartLink from '@sephora-asia/ui-smart-link'
import UiSmartImage from '@sephora-asia/ui-smart-image'
import type { ProductListingBannerProps } from '~/types/components/product-listing.types'
import { vElementVisibility } from '@vueuse/components'

const props = defineProps<ProductListingBannerProps>()
const pageMetaStore = usePageMetaStore()
const { trackEvent } = useGtmTrack()

const linkAttributes = computed(() => {
  if (!props.banner.urlPath) return
  return {
    to: props.banner.urlPath,
    rel: props.banner.isOpenInNewTab ? 'noopener noreferrer' : null,
    target: props.banner.isOpenInNewTab ? '_blank' : null,
  }
})

function onTrackEvent(eventType: string) {
  trackEvent({
    event: `lp_product_listing_banner_${eventType}`,
    params: {
      banner_name: props.banner.internalName,
      banner_position: props.bannerIndex + 1,
      content_banner_position: props.componentPosition,
      campaign_name: pageMetaStore.campaignName,
      page_path: useRoute().path,
    },
  })
}

function onBannerImpression(isVisible: boolean) {
  if (isVisible) {
    onTrackEvent('impression')
  }
}

function onBannerClicked() {
  onTrackEvent('click')
}
</script>

<style lang="scss" scoped>
.product-listing-banner {
  :deep(.image) {
    border-radius: var(--size-radius-medium);
  }
}
</style>
